// Shared marketing footer (landing, platform, …). Locale-aware links.

import { Link } from "react-router-dom";

import { localePath } from "@/i18n/config";
import { useDict, useLocale } from "@/i18n/LocaleProvider";

export function SiteFooter() {
  const locale = useLocale();
  const { footer, nav } = useDict();

  return (
    <footer
      className="px-4 sm:px-6 py-8 sm:py-10"
      style={{
        background: "rgb(var(--color-bg-deep))",
        borderTop: "1px solid rgb(var(--color-stroke))",
      }}
    >
      <div className="max-w-[1100px] mx-auto flex flex-col sm:flex-row sm:flex-wrap sm:justify-between gap-8 sm:gap-6">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <img
              src="/logo-small.png"
              alt="TrueHacking logo"
              width={80}
              height={80}
              className="h-6 w-auto"
            />
            <div className="font-display text-[14px] font-bold text-accent tracking-[0.12em]">
              TrueHacking
            </div>
          </div>
          <div className="font-mono text-[10px] text-dim max-w-[260px] leading-[1.6]">
            {footer.blurb}
          </div>
        </div>
        <div className="flex gap-10 sm:gap-6">
          <div className="font-mono text-[10px] text-muted">
            <div className="text-accent uppercase tracking-[0.1em] mb-2 font-bold">
              {footer.product}
            </div>
            <div className="mb-1">
              <Link to={localePath(locale, "platform")} className="no-underline text-muted">
                {nav.platform}
              </Link>
            </div>
            <div className="mb-1">
              <Link to={localePath(locale, "pricing")} className="no-underline text-muted">
                {footer.pricing}
              </Link>
            </div>
            <div className="mb-1">
              <Link to={localePath(locale, "blog")} className="no-underline text-muted">
                {nav.blog}
              </Link>
            </div>
          </div>
          <div className="font-mono text-[10px] text-muted">
            <div className="text-accent uppercase tracking-[0.1em] mb-2 font-bold">
              {footer.company}
            </div>
            <div className="mb-1">
              <a
                href="mailto:support@truehacking.ai"
                className="no-underline text-muted break-all"
              >
                support@truehacking.ai
              </a>
            </div>
            <div className="mb-1">
              <Link to={localePath(locale, "privacy")} className="no-underline text-muted">
                {footer.privacy}
              </Link>
            </div>
            <div className="mb-1">
              <Link to={localePath(locale, "terms")} className="no-underline text-muted">
                {footer.terms}
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-[1100px] mx-auto mt-8 pt-6 border-t border-stroke font-mono text-[9px] text-dim text-center">
        © {new Date().getFullYear()} True Hacking. {footer.rights}
      </div>
    </footer>
  );
}
